import { createContext } from "react"
import { AuthContextData } from "../../types/user/AuthContextData"

const AuthContext = createContext<AuthContextData | undefined>(undefined)

export default AuthContext
